const GB_FloatDiff = 0.0001;

const LessThanValue = -1;
const EqualsValue = 0;
const GreaterThanValue = 1;

/* Scale-up pattern constants; use with GBUtil method GBInterpolate */
export const GB_SC_Linear = 1;
export const GB_SC_SShaped = 2;
export const GB_SC_Exponential = 3;
export const GB_SC_FrontLoaded = 4;
export const GB_SC_Duplicate = 5;
export const GB_SC_Normalize = 6;
export const GB_SC_Multiply = 7;
export const GB_NumScaleUpPatterns = 7;

/**
 * @param {number} value
 * @param {number} value2
 * @param {number} tolerance
 * @returns {number}
 */
function CompareValue(value, value2, tolerance) {
    let val = value - value2;

    if (val > 0) {
        return GreaterThanValue;
    } else if (val < 0) {
        return LessThanValue;
    } else {
        return EqualsValue;
    }
}

// eslint-disable-next-line
function GBFill(arr, type, params) {
    switch (type) {
        case GB_SC_Linear:
            arr = GBInterpolate(arr, type);
            break;
        case GB_SC_SShaped:
            arr = GBInterpolate(arr, type);
            break;
        case GB_SC_Exponential:
            arr = GBInterpolate(arr, type);
            break;
        case GB_SC_FrontLoaded:
            arr = GBInterpolate(arr, type);
            break;
        case GB_SC_Duplicate:
            arr = GBDuplicate(arr);
            break;
        case GB_SC_Normalize:
            arr = GBNormalize(arr);
            break;
        case GB_SC_Multiply:
            arr = GBMultiply(arr);
            break;
        default:
            break;
    }

    return arr;
}

export function GBDuplicate(arr) {
    for (let i = 1; i < arr.length; i++) {
        arr[i] = arr[0];
    }

    return arr;
}

export function GBMultiply(arr, mult) {
    for (let i = 0; i < arr.length; i++) {
        arr[i] = arr[i] * mult;
    }

    return arr;
}

function GBNormalizeArray(arr, total) {
    let i = 0;
    let sum = 0.0;
    let multiplier = 0.0;

    /* Sum will hold the sum of all the values in values that we want to normalize. */

    /* Sum all values in the array. */
    for (i = 0; i < arr.length; i++) {
        sum = sum + arr[i];
    }

    /* If the values sum to 0, we will multiply them all by 0. Otherwise, we
    will multiply them all by what we want them to sum to divided by their
    actual sum. */
    if (CompareValue(sum, 0.0, GB_FloatDiff) === EqualsValue) {
        multiplier = 0;
    } else {
        multiplier = total / sum;
    }

    /* Multiply each value by our multiplier. */
    for (let i = 0; i < arr.length; i++) {
        arr[i] = arr[i] * multiplier;
    }

    return arr;
}

export function GBNormalize(arr) {
    /* This flag tells us whether we should normalize to 1 or 100. */
    let valueGreatThanOne = false;

    for (let i = 0; i < arr.length; i++) {
        if (CompareValue(arr[i], 1.0, GB_FloatDiff) === GreaterThanValue) {
            valueGreatThanOne = true;
        }
    }

    if (valueGreatThanOne) {
        arr = GBNormalizeArray(arr, 100);
    } else {
        arr = GBNormalizeArray(arr, 1);
    }

    return arr;
}

export function GBInterpolate(arr, pattern) {
    let i = 0;
    let startVal = 0;
    let endVal = 0;
    let diff = 0;
    let newVal = 0;
    let SL,
        PL = 0;
    let x,
        Q,
        P = 0;
    let linearVals = [];

    /* There is nothing to interpolate unless there are three or more values. */
    if (arr.length < 2) {
        return arr;
    }

    startVal = arr[0];
    endVal = arr[arr.length - 1];
    diff = endVal - startVal;

    switch (pattern) {
        case GB_SC_Linear:
            /*
                current value = first value + ((final value - first value) / (final index - first index)) *
                (current index - first index)
            */
            for (i = 1; i <= arr.length - 2; i++) {
                newVal = startVal + (diff / (arr.length - 1)) * i;
                arr[i] = newVal;
            }
            break;

        case GB_SC_SShaped:
            /*
                current value := first value + ((final value - first value) * e^x) / (1 + e^x), where
                x = 2 * (current index - ((first index + last index) / 2))
            */
            for (i = 1; i <= arr.length - 2; i++) {
                x = 2 * (i - (arr.length - 1) / 2);
                newVal = startVal + (diff * Math.exp(x)) / (1 + Math.exp(x));
                arr[i] = newVal;
            }
            break;

        case GB_SC_Exponential:
            for (i = 1; i <= arr.length - 2; i++) {
                if (startVal > 1) {
                    Q = startVal;
                } else {
                    Q = 1;
                }

                if (endVal === 0) {
                    //ln(0) doesn't exist =/
                    P =
                        (Math.log(Math.pow(10, arr.length - 1)) - Math.log(Q * Math.pow(10, arr.length - 1))) /
                        (arr.length - 1);
                } else {
                    P =
                        (Math.log(endVal * Math.pow(10, arr.length - 1)) - Math.log(Q * Math.pow(10, arr.length - 1))) /
                        (arr.length - 1);
                }

                if (arr[i - 1] > 1) {
                    newVal = arr[i - 1] * Math.exp(P);
                } else {
                    newVal = Math.exp(P);
                }

                arr[i] = newVal;
            }
            break;

        case GB_SC_FrontLoaded:
            linearVals.length = arr.length - 1;

            GBInterpolate(arr, GB_SC_Linear);

            for (i = 0; i <= arr.length - 2; i++) {
                linearVals[i] = arr[i]; // Save the interpolation to an array
            }

            if (startVal > 1) {
                SL = startVal;
            } else {
                SL = 1;
            }

            if (endVal >= 10) {
                for (let i = 1; i <= arr.length - 2; i++) {
                    if (linearVals[i - 1] > 1) {
                        PL = linearVals[i - 1];
                    } else {
                        PL = 1;
                    }

                    if (startVal === endVal) {
                        newVal = startVal;
                    } else {
                        newVal =
                            ((Math.log(linearVals[i]) - Math.log(PL)) / (Math.log(endVal) - Math.log(SL))) * diff +
                            arr[i - 1];
                    }

                    arr[i] = newVal;
                }
            }
            break;

        default:
            break;
    }

    return arr;
}
